export class Cookie {
  static write(key: string, value: string) {
    document.cookie = `${key}=${value}`
  }

  static read(key: string) {
    const finded =  document.cookie.split(';').find(row => {
      return key === row.split('=')[0].trim()
    })
    return finded?.split('=')[1].trim()
  }
}
